import React, { useState } from "react"
import { StaticQuery, graphql, Link } from "gatsby"
import Img from "@kframesa/react-crosscast-lazy-image"

import { sMenu } from "../styled/menu"
import { sLayout } from "../styled/layout"
import facebook from "../assets/images/facebook.svg"
import instagram from "../assets/images/instagram.svg"

import useSiteMetadata from "../hooks/use-site-metadata"
import { getCategoryUrl, getPostUrl } from "../utilities"

const Menu = ({ open, toggleMenu }) => {
  const [section, setSection] = useState()
  const { baseSite, social } = useSiteMetadata()
  return (
    <StaticQuery
      query={detailsQuery}
      render={data => (
        <sMenu.Wrapper open={open}>
          <sLayout.Container>
            <sMenu.Close className="icon-close" onClick={toggleMenu} />
            <sMenu.Nav>
              {data.categories &&
                data.categories.edges.map(({ node: category }) => (
                  <div key={category.slug}>
                    <sMenu.NavButton
                      className="icon-down"
                      onClick={() => setSection(category.slug)}
                      open={section === category.slug}
                    >
                      {category.name}
                    </sMenu.NavButton>
                    <sMenu.NavList open={section === category.slug}>
                      {category.subcategories &&
                        category.subcategories.map(subcategory => (
                          <sMenu.NavItem key={subcategory.slug}>
                            <Link to={getCategoryUrl(subcategory.slug)} activeClassName="active" onClick={toggleMenu}>
                              {subcategory.name}
                            </Link>
                          </sMenu.NavItem>
                        ))}
                    </sMenu.NavList>
                  </div>
                ))}
              {data.lastPosts &&
                data.lastPosts.edges.map(({ node: lastPost }) => (
                  <div key={lastPost.slug}>
                    <sMenu.NavButton>In evidenza</sMenu.NavButton>
                    <sMenu.Hot>
                      <Link to={getPostUrl(lastPost.slug)}>
                        <sMenu.HotImage>
                          <Img
                            platformSlug={lastPost.featuredImage.platformSlug}
                            imageGuid={lastPost.featuredImage.guid}
                            type={lastPost.featuredImage.type}
                            fixed={{
                              width: 275,
                              height: 155,
                            }}
                            alt={lastPost.featuredImage.alt}
                            width={lastPost.featuredImage.width}
                            height={lastPost.featuredImage.height}
                            ext={lastPost.featuredImage.ext}
                          />
                        </sMenu.HotImage>
                        <sMenu.HotCaption>
                          <span>{lastPost.category.name}</span>
                          <strong>{lastPost.title}</strong>
                          <p>{lastPost.abstract}</p>
                        </sMenu.HotCaption>
                      </Link>
                    </sMenu.Hot>
                  </div>
                ))}
            </sMenu.Nav>
            <sMenu.Social>
              {social.facebook ? (
                <a
                  href={`https://www.facebook.com/${social.facebook}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Facebook"
                >
                  <span className="visuallyhidden">Facebook</span>
                  <img src={facebook} alt="Facebook" width="19" height="19" />
                </a>
              ) : null}
              {social.instagram ? (
                <a
                  href={`https://www.instagram.com/${social.instagram}/`}
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Instagram"
                >
                  <span className="visuallyhidden">Instagram</span>
                  <img src={instagram} alt="Instagram" width="22" height="22" />
                </a>
              ) : null}
            </sMenu.Social>
            {baseSite ? (
              <sMenu.Site href={baseSite.url} target="_blank" rel="noopener noreferrer">
                {baseSite.title}
              </sMenu.Site>
            ) : null}
          </sLayout.Container>
        </sMenu.Wrapper>
      )}
    />
  )
}

export default Menu

const detailsQuery = graphql`
  query {
    categories: allCrossCastMagCategory(filter: { parentId: { eq: null } }) {
      edges {
        node {
          slug
          name
          subcategories {
            slug
            name
          }
        }
      }
    }
    lastPosts: allBlogPost(sort: { fields: publishedAt, order: DESC }, limit: 1) {
      edges {
        node {
          slug
          title
          featuredImage {
            guid
            platformSlug
            type
            alt
            width
            height
            ext
          }
          category {
            name
          }
          abstract
        }
      }
    }
  }
`
